import boletaApi from "./boletaApi";

export const getEmployee = async (employeeId) => {
  try {
    const response = await boletaApi.get("/getEmployee", {
      params: { id: employeeId },
    });
    return response.data;
  } catch (error) {
    const { response } = error;
    return response;
  }
};
